import {
  arrayOf,
  bool,
  func,
  node,
  number,
  oneOfType,
  shape,
  string,
} from "prop-types";
import { createContext, useCallback, useState } from "react";
import { useHistory } from "react-router-dom";

import FnrVerticalGap from "UI/commonContainers/FnrVerticalGap";

import Content from "./Content";
import Tabs from "./Tabs";

const FnrTabsContext = createContext();

const FnrTabs = ({
  defaultKey,
  tabs = [],
  divider,
  padding = 20,
  activeTabKey,
  setActiveTabKey,
  children,
  isLoading,
  clip,
  contentOnly,
  ...rest
}) => {
  const [activeLocalKey, setActiveLocalKey] = useState(
    defaultKey || tabs?.[0]?.key
  );
  const history = useHistory();

  const handleSetActiveTab = useCallback(
    (newKey) => {
      if (typeof setActiveTabKey === "function") setActiveTabKey(newKey);
      else setActiveLocalKey(newKey);
      const tabData = tabs.find(({ key }) => key === newKey);
      if (tabData?.url) history.push(tabData.url);
    },
    [setActiveTabKey, tabs, history]
  );

  if (tabs.length === 0) return null;

  return (
    <FnrTabsContext.Provider
      value={{
        activeKey: activeTabKey || activeLocalKey,
        handleSetActiveTab,
        tabs,
        padding,
        isLoading,
        clip,
      }}
    >
      {/* This is to allow making tabs composable. */}
      {children ? (
        children
      ) : (
        <FnrVerticalGap data-cy="FnrTabs_Container" gap={8} {...rest}>
          {!contentOnly && <Tabs divider={divider} />}
          <Content />
        </FnrVerticalGap>
      )}
    </FnrTabsContext.Provider>
  );
};

FnrTabs.propTypes = {
  defaultKey: string,
  tabs: arrayOf(
    shape({
      key: string.isRequired,
      content: func.isRequired,
      label: oneOfType([node, string]).isRequired,
      icon: string,
      url: string,
      amount: number,
      disabled: bool,
    })
  ),
  divider: node,
  padding: number,
  activeTabKey: string,
  setActiveTabKey: func,
  children: node,
  isLoading: bool,
  clip: bool,
  contentOnly: bool,
};

FnrTabs.Tabs = Tabs;
FnrTabs.Content = Content;

export { FnrTabsContext };
export default FnrTabs;
